/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} App_Sign_In_TitleInputs */

const en_app_sign_in_title = /** @type {(inputs: App_Sign_In_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in - AnyAPI`)
};

const zh_hans1_app_sign_in_title = /** @type {(inputs: App_Sign_In_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登录 - AnyAPI`)
};

const pt_br2_app_sign_in_title = /** @type {(inputs: App_Sign_In_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrar - AnyAPI`)
};

const es_app_sign_in_title = /** @type {(inputs: App_Sign_In_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciar sesión - AnyAPI`)
};

const fr_app_sign_in_title = /** @type {(inputs: App_Sign_In_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connexion - AnyAPI`)
};

const de_app_sign_in_title = /** @type {(inputs: App_Sign_In_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anmelden | AnyAPI`)
};

const ru_app_sign_in_title = /** @type {(inputs: App_Sign_In_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вход - AnyAPI`)
};

const it_app_sign_in_title = /** @type {(inputs: App_Sign_In_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accedi - AnyAPI`)
};

/**
* | output |
* | --- |
* | "Sign in - AnyAPI" |
*
* @param {App_Sign_In_TitleInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const app_sign_in_title = /** @type {((inputs?: App_Sign_In_TitleInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<App_Sign_In_TitleInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_app_sign_in_title(inputs)
	if (locale === "pt-BR") return pt_br2_app_sign_in_title(inputs)
	if (locale === "es") return es_app_sign_in_title(inputs)
	if (locale === "fr") return fr_app_sign_in_title(inputs)
	if (locale === "de") return de_app_sign_in_title(inputs)
	if (locale === "ru") return ru_app_sign_in_title(inputs)
	if (locale === "it") return it_app_sign_in_title(inputs)
	return en_app_sign_in_title(inputs)
});